import Box from '@classify/react-core-components/Box';

import { renderTwigReactComponent } from 'Modules/dom';
import useCanDisplayMerchandising from 'Modules/training-merchandising/hooks/useCanDisplayMerchandising';
import BigInfoBanner from 'Modules/training-merchandising/components/BigInfoBanner';

const Banner = () => {
  const canDisplay = useCanDisplayMerchandising();

  if (!canDisplay) {
    return null;
  }

  return (
    <div className="grid-wrapper">
      <div className="grid-inner">
        <Box sx={{ marginTop: 11, marginBottom: 1 }}>
          <BigInfoBanner />
        </Box>
      </div>
    </div>
  );
};

export default function initForumMerchandisingBanner() {
  const contentElement = document.getElementById('mainContent');
  const forumUrlMatch = document.location.pathname.match(/forum\/sujet\//);

  if (!contentElement || !forumUrlMatch) {
    return;
  }

  const targetElement = document.createElement('div');

  contentElement.appendChild(targetElement);

  renderTwigReactComponent(targetElement, Banner);
}
